import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../globalState/GlobalState';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import Player1Info from './player1Details/player1Info/Player1Info';
import Player1Tabs from './player1Details/player1Tabs/Player1Tabs';
import PlaceholderComponent1 from '../../uiElements/placeholderComponents/placeholderComponent1/PlaceholderComponent1';
import { PLAYER_DELETED } from '../../../catalog/Comments';
import './css/Player1.css';
import { getPlayerInfo } from '../../../catalog/Website';

const Player1 = (props) => {
    const { name, alumni, featureImage, profileImage, details, summary, bio, texts, seasons, stats, gameLogs, deleted, loadingSpinner } = props;
    const { globalState } = useContext(context);

    // const getBreadCrumbsLinks = () => {
    //     return [
    //         {
    //             title: 'Home',
    //             link: '/',
    //         },
    //         {
    //             title: 'Roster',
    //             link: '/roster',
    //         },
    //     ];
    // };

    return (
        <>
            {/* <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={name} marginLeft="100px" /> */}
            {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                <>
                    {deleted ? (<PlaceholderComponent1 text={PLAYER_DELETED} />) : (
                        <div className="player1-container full-width">
                            <Player1Info name={name} alumni={alumni} featureImage={featureImage} profileImage={profileImage} details={details} summary={summary} seasons={seasons} />
                            {/* <div className="player1-container-distance m-t-30px" />
                            <Player1StatsBox2 isGoalie={getPlayerInfo(details, 'Position') === 'Goalie'} stats={stats} /> */}
                            <div className="player1-container-distance m-t-20px" />
                            <Player1Tabs bio={bio} texts={texts} teamNumber={getPlayerInfo(details, 'Team Number')} position={getPlayerInfo(details, 'Position')} stats={stats} gameLogs={gameLogs} />
                        </div>
                    )}
                </>
            )}
        </>
    );
};

Player1.propTypes = {
    name: PropTypes.string.isRequired,
    alumni: PropTypes.bool.isRequired,
    featureImage: PropTypes.string.isRequired,
    profileImage: PropTypes.string.isRequired,
    details: PropTypes.array.isRequired,
    summary: PropTypes.string.isRequired,
    bio: PropTypes.string.isRequired,
    texts: PropTypes.array.isRequired,
    seasons: PropTypes.array.isRequired,
    stats: PropTypes.array.isRequired,
    gameLogs: PropTypes.array.isRequired,
    deleted: PropTypes.bool.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(Player1);
